const ProgressBar = (props) => {
    const {className, current, label, steps = false, total} = props;
    const rawPercentage = steps
      ? ((current + 1) / total.length) * 100
      : (current / total) * 100;
    const progressPercentage = Number.isFinite(rawPercentage)
      ? Math.min(100, Math.max(0, rawPercentage))
      : 0;

    const classNames = `w-full overflow-hidden bg-white rounded-full h-2.5 ${className}`
    return (
        <>
        {label && (<p className="text-sm text-slate-700">{current} {label}</p>)}
      <div className={classNames}>
        <div
          role="progressbar"
          aria-label={label || "Progress"}
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow={Math.round(progressPercentage)}
          className="bg-slate-950 h-2.5 rounded-full"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      </>
    );
  };

  export default ProgressBar;
